import React from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import useSyncPromise from '../../utils/react/useSyncPromise';
import fetchUser from '../../utils/gaia/fetchUser';
import gettext from '../../utils/django/gettext';

function useIsVisible() {
    const [user] = useSyncPromise(fetchUser());
    return user && !user.isAuthenticated;
}

const sharedProps = {
    children: gettext('Sign Up'),
    href: `/register/${Gaia.nextFromRegister}`,
};

function Toolbar({style, ...props}: ButtonProps) {

    if (!useIsVisible()) return null;

    return <Button
        {...props}
        {...sharedProps}
        style={{...style, color: '#fff'}}
        variant="contained"
        color="primary"
    />;
}

function HamburgerMenu(props: MenuItemAnchorProps) {
    if (!useIsVisible()) return null;
    return <MenuItemAnchor {...props} {...sharedProps} />;
}

export default {Toolbar, HamburgerMenu};
